function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 50,
  r: 10,
  fill: "#a380ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "0.3424657534246575s",
  calcMode: "spline",
  keyTimes: "0;1",
  values: "12;0",
  keySplines: "0 0.5 0.5 1",
  begin: "0s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  repeatCount: "indefinite",
  dur: "1.36986301369863s",
  calcMode: "discrete",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "#a380ff;#a380ff;#a380ff;#a380ff;#a380ff",
  begin: "0s"
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 50,
  r: 10,
  fill: "#a380ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1.36986301369863s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;12;12;12",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "0s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1.36986301369863s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "0s"
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 10,
  fill: "#a380ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1.36986301369863s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;12;12;12",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.3424657534246575s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1.36986301369863s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.3424657534246575s"
}));

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 50,
  r: 10,
  fill: "#a380ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1.36986301369863s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;12;12;12",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.684931506849315s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1.36986301369863s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.684931506849315s"
}));

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 50,
  r: 10,
  fill: "#a380ff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1.36986301369863s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;12;12;12",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-1.0273972602739727s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1.36986301369863s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-1.0273972602739727s"
}));

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      margin: "auto",
      background: "#fff",
      display: "block"
    },
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.84225533.svg";
export { ForwardRef as ReactComponent };